import React, { useEffect, useState } from "react";
import {Redirect} from 'react-router-dom';
import {Box, Button, Typography, Container} from '@material-ui/core';

 export const Page404 = ({h3text, txtsecondary, bgcolor}) => {
    const [direction, setdirection] = useState('');
    const [redirect, setredirect] = useState(false);
function handleLogout(){    
    setredirect(true)
    setdirection("/AML")
}
    return (
        <div style={{background: bgcolor,color:'white'}} >
        {redirect &&
            <Redirect to={direction}/>
            }
    <Container>
        <Box sx={{margin: 'auto', textAlign: 'center' }}>
            <Typography variant="h3" paragraph>
             {h3text}
              
            </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
              {txtsecondary}
          </Typography>
          <Button style={{marginTop: '10px'}} size="large" onClick={() => handleLogout()} variant="contained" >
            Go to Home
          </Button>
        </Box>
    <div style={{padding:'8px'}}></div>
    </Container>
  </div>
    )
}